// tslint:disable:max-classes-per-file
import { Action } from '@ngrx/store';

import { Account } from '../../model/account';

export const LOAD_ACCOUNT_INFORMATION = '[Account] Load Account Information';
export const LOAD_ACCOUNT_INFORMATION_SUCCESS =
  '[Account] Load Account Information Success';
export const LOAD_ACCOUNT_INFORMATION_FAIL =
  '[Account] Load Account Information Fail';

export class LoadAccountInformation implements Action {
  public readonly type: string = LOAD_ACCOUNT_INFORMATION;

  constructor(public payload: any = null) {}
}

export class LoadAccountInformationSuccess implements Action {
  public readonly type: string = LOAD_ACCOUNT_INFORMATION_SUCCESS;

  constructor(public payload: Account) {}
}

export class LoadAccountInformationFail implements Action {
  public readonly type: string = LOAD_ACCOUNT_INFORMATION_FAIL;

  constructor(public payload: any) {}
}

export type AccountActions =
  | LoadAccountInformation
  | LoadAccountInformationSuccess
  | LoadAccountInformationSuccess;
